import { render, staticRenderFns } from "./beanAccount.vue?vue&type=template&id=3bfe7770&scoped=true"
import script from "./beanAccount.vue?vue&type=script&lang=js"
export * from "./beanAccount.vue?vue&type=script&lang=js"
import style0 from "./beanAccount.vue?vue&type=style&index=0&id=3bfe7770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfe7770",
  null
  
)

export default component.exports